import { Injectable, OnInit } from '@angular/core';
import { ProjectsService } from '@layouts/default/layouts/guest/pages/projects/projects.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { StorageService } from './storage.service';
import { Tag } from '@shared/interfaces/project/tag.interface';
import { Config } from '@shared/config';

@Injectable({
  providedIn: 'root',
})
export class HeaderService implements OnInit {
  eventCategory: boolean = false;
  previousUrl: any = [];
  ukrainianCategories: Array<number> = [];

  constructor(
    public projects: ProjectsService,
    public router: Router,
    public storage: StorageService
  ) {
    this.checkUkrainianRoutes();
  }

  ngOnInit() {
    this.ukrainianCategories = Config.UKRAINE_CATEGORY.split(',').map(Number);
  }

  get isAuthFromUkraine() {
    return this.storage.isAuthFromUkraine;
  }

  get isAuthFromWcd() {
    return this.storage.isAuthFromWCD;
  }

  get isAuthFromBackbase() {
    return this.storage.isAuthFromBackbase;
  }

  hideTabs(id: number) {
    this.projects.currentProjectCategories$.subscribe((categories: Tag[]) => {
      this.eventCategory = categories
        ? categories.filter((cat) => this.ukrainianCategories.includes(cat.id)).length > 0
        : false;
    });
  }

  checkUkrainianRoutes() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.previousUrl.includes('/helpukraine')) {
          return;
        } else {
          this.previousUrl.push(event.url);
        }
      });
  }
}
